export default "__VITE_ASSET__2d5d4a3a__"